module.exports = __webpack_public_path__ + "static/media/DL_1.e0322610.jpg";